"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkerExample = exports.DisabledMarkerExample = void 0;

var _react = _interopRequireDefault(require("react"));

var _CornerDateMarker = _interopRequireDefault(require("../date-picker-calendar/CornerDateMarker"));

var _DisabledDateMarker = _interopRequireDefault(require("../date-picker-calendar/DisabledDateMarker"));

var _OutlineDateMarker = _interopRequireDefault(require("../date-picker-calendar/OutlineDateMarker"));

var _interfaces = require("../interfaces");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var MarkerExample = function MarkerExample(_ref) {
  var type = _ref.type;
  return type === _interfaces.DateMarkerType.Corner ? (0, _core.jsx)(_helperComponents.MarkerExampleWrapper, {
    role: "presentation"
  }, (0, _core.jsx)(_CornerDateMarker.default, {
    hasMarker: true,
    size: _constants.MARKER_EXAMPLE_SIZE
  })) : (0, _core.jsx)("div", {
    role: "presentation"
  }, (0, _core.jsx)(_OutlineDateMarker.default, {
    type: type,
    size: _constants.MARKER_EXAMPLE_SIZE
  }));
};

exports.MarkerExample = MarkerExample;
MarkerExample.displayName = 'MarkerExample';

var DisabledMarkerExample = function DisabledMarkerExample() {
  return (0, _core.jsx)(_helperComponents.MarkerExampleWrapper, {
    role: "presentation"
  }, (0, _core.jsx)(_DisabledDateMarker.default, {
    isDisabled: true,
    wrapperWidth: _constants.MARKER_EXAMPLE_SIZE,
    wrapperHeight: _constants.MARKER_EXAMPLE_SIZE,
    markerWidth: _constants.MARKER_EXAMPLE_SIZE
  }));
};

exports.DisabledMarkerExample = DisabledMarkerExample;
DisabledMarkerExample.displayName = 'DisabledMarkerExample';